const CONSENT_KEY = 'pediatricConsentInfo';

export function readConsent() {
  try {
    return JSON.parse(sessionStorage.getItem(CONSENT_KEY)) || null;
  } catch {
    return null;
  }
}

export function writeConsent(patch) {
  const prev = readConsent() || {};
  const next = { ...prev, ...patch };
  Object.keys(next).forEach((k) => {
    if (next[k] === '' || next[k] === undefined) {
      delete next[k];
    }
  });
  sessionStorage.setItem(CONSENT_KEY, JSON.stringify(next));
  return next;
}

export function needProvider(c) {
  return !c || typeof c.consent_required !== 'boolean';
}

export function needGuardian(c) {
  const m = (c?.consent_method || '').trim().toLowerCase();
  return c?.consent_required === true && (
    !m ||
    (m === 'onsite' && !c.guardian_name) ||
    (m === 'email' && !c.guardian_email)
  );
}
